import classNames from 'classnames';
import Loading from 'legacy/components/generic/Loading';

import { ValueAdjustment as theme } from 'legacy/css-modules';

const ValueAdjustment = ({
  loading,
  isLimitedReport,
  valueAdjustment,
  valueAdjustmentDisplay,
  hasAdjustments
}) => {
  if (!hasAdjustments || isLimitedReport || valueAdjustment === 0) {
    return null;
  }
  return (
    <div className={theme.Container}>
      <h3 className={theme.Heading}>Adjusted Value Difference</h3>
      <div
        className={classNames(theme.Adjustment, {
          [theme.positive]: valueAdjustment > 0,
          [theme.negative]: valueAdjustment < 0
        })}
      >
        <Loading
          size="xs"
          className={theme.Loading}
          loading={loading}
          dataHcName="property-details-adjustment-value"
        >
          {valueAdjustmentDisplay}
        </Loading>
      </div>
    </div>
  );
};

export default ValueAdjustment;
